export const time_condition = {
  modal: {
    remove: {
      content: `Apakah Anda yakin ingin menghapus syarat waktu <b>{name}<b>?`
    },

    add_interval: {
      days: 'Pilih jumlah hari per minggu',
      worktime: 'Jam kerja'
    }
  },

  form: {
    title: {
      edit: {
        main: 'Kondisi data waktu'
      }
    },

    buttons: {
      create_time_interval: 'Tambah Interval'
    }
  },

  table: {
    field: {
      timezone: 'Zona waktu'
    }
  }
};
